import { render, staticRenderFns } from "./ItsOrderDepartRaw.vue?vue&type=template&id=e4f20fea&scoped=true&"
import script from "./ItsOrderDepartRaw.vue?vue&type=script&lang=js&"
export * from "./ItsOrderDepartRaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f20fea",
  null
  
)

export default component.exports